// El copy visible debe coincidir con el catálogo oficial de respuestas.
export function answerLabel(_questionId, option) {
  return option.label;
}
